"use strict";
import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { carrierInvoiceWithLoadPath } from "../flow_mode/dashboard_paths";
import loadHelper from "../loads";
import { push } from "../app_history";
export default React.createClass({
  getInitialState: function() {
    return {};
  },
  render: function() {
    return /* @__PURE__ */ jsx("div", { className: "document-indexer__progress", children: /* @__PURE__ */ jsx("div", { className: "indexer-progress__container-ltl-reconcile", children: /* @__PURE__ */ jsxs("ul", { className: "indexer-progress__list", children: [
      this.renderReconcileInvoiceStep(),
      /* @__PURE__ */ jsxs("li", { className: "indexer-progress__item indexer-progress__item--clickable indexer-progress__item__active", children: [
        /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator", children: /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator-inner" }) }),
        /* @__PURE__ */ jsx("span", { children: "Review and Submit" })
      ] })
    ] }) }) });
  },
  renderReconcileInvoiceStep: function() {
    const clickEnabled = !loadHelper.isMovedToTmsQueue(this.props.invoice);
    const classes = classNames({
      "indexer-progress__item": true,
      "indexer-progress__item--clickable": clickEnabled,
      "indexer-progress__item__completed": true
    });
    const onClick = clickEnabled ? this.redirectToReconcileInvoicePage : null;
    return /* @__PURE__ */ jsxs("li", { className: classes, onClick, children: [
      /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator", children: /* @__PURE__ */ jsx("div", { className: "indexer-progress__indicator-inner" }) }),
      /* @__PURE__ */ jsx("span", { children: "Reconcile Invoice" }),
      /* @__PURE__ */ jsx("hr", { className: "indexer-progress__trailer" })
    ] });
  },
  redirectToReconcileInvoicePage: function() {
    const url = carrierInvoiceWithLoadPath(
      this.props.invoice.load_state_id,
      this.props.invoice.id,
      true
    );
    push(url.pathString(), {
      onDone: this.props.location.query.onDone
    });
  }
});
